import { AppDispatch } from '../store'
import overviewActionTypes from '../actionTypes/overview.actionTypes'
import {
    OverviewWidgetResponse_FieldGroup,
    OverviewWidgetResponse_IndexComponent
} from '../proto/generated/overview-widget'

const dispatchFieldGroup = (dispatch: AppDispatch, fieldGroup: OverviewWidgetResponse_FieldGroup[]) => {
    dispatch({
        type: overviewActionTypes.SET_FIELD_GROUP,
        payload: fieldGroup
    })
}

const dispatchIndexComponents = (dispatch: AppDispatch, indexComponents: OverviewWidgetResponse_IndexComponent[]) => {
    dispatch({
        type: overviewActionTypes.SAVE_INDEX_COMPONENTS,
        payload: indexComponents
    })
}

const overviewActions = {
    dispatchFieldGroup,
    dispatchIndexComponents
}

export default overviewActions